export default "__VITE_ASSET__D008ZuQM__"